/**
 * Shared by Sentry and PostHog: both report only errors thrown by this site's
 * own code, never by each other's library, browser extensions or any other
 * third-party script (e.g. Google sign-in).
 */

/** Scripts served from appio.so or any subdomain (our bundle, cdn.appio.so). */
export const OWN_SCRIPT = /^https:\/\/([a-z0-9-]+\.)*appio\.so\//;

/** Messages raised by browser extensions, and the browser's opaque "Script error." for scripts from other sites. */
export const FOREIGN_MESSAGE = /runtime\.sendMessage|Extension context invalidated|^Script error\.?$/;

/** Browser extensions' own files (Chrome, Firefox, Safari, Edge). */
export const EXTENSION_SCRIPT = /^([a-z-]+-extension|webkit-masked-url):/;

// Each SDK is bundled into its own chunk (vite.config.ts), so the other tool
// can tell from the file name that an error was thrown inside it.
export const SENTRY_CHUNK = /\/assets\/vendor-sentry-[^/]*\.js/;
export const POSTHOG_CHUNK = /\/assets\/vendor-posthog-[^/]*\.js|posthog\.com/;
